import React, { memo, useContext, useEffect, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { UncertainContext } from '../../contexts/uncertainContext';
import { default_avatar, default_design } from '../../static/default_design';
import { Footer } from '../Footer';
import { NarrativesList } from '../UiKit/NarrativesList';
import { Preview } from '../UiKit/Preview';
import { Txt } from '../UiKit/Txt';
import { narrativesComponents } from './narratives';
import { Uncertain } from './Uncertain';
import Soon from './Soon';

const pageComponents = {
  ...narrativesComponents,
  uncertain: <Uncertain
    noBodyView={true}
    noHeading={true}
    hints={false}
    noHints={true}
    numbers={true}
    planets={true}
    advanced={false}
    hoverable={true}
    noSettings={true}
    noSearch={true}
  />,
};

export const DesignPages = memo(({
  user,
  avatar,
  penta,
  narrative,
  publ
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const uncertain = useContext(UncertainContext);
  const $ = context.$;

  const pageAvatar = useMemo(() => {
    if (!avatar || !uncertain?.available || uncertain.main === 'uncertain' || !uncertain.designs?.[uncertain.main]) {
      return avatar;
    }
    return {
      ...avatar,
      design: uncertain.designs[uncertain.main],
    };
  }, [avatar, uncertain?.available, uncertain?.main, uncertain?.designs]);


  const navigate = useNavigate();
  const location = useLocation();

  const drawArray = penta ? penta.members : [{
    user: user,
    avatar: pageAvatar
  }]

  const pentaFontSize = '0.8em';

  const showUncertain = Boolean(!penta && uncertain?.available);
  const showNarrativePages = !showUncertain || uncertain.main !== 'uncertain';
  const embedRef = useRef(null);
  const prevMainRef = useRef(uncertain?.main);

  useEffect(() => {
    const prev = prevMainRef.current;
    prevMainRef.current = uncertain?.main;
    if (!showUncertain || uncertain.main === 'uncertain' || prev !== 'uncertain') return undefined;
    const node = embedRef.current;
    if (!node) return undefined;
    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return undefined;
  }, [showUncertain, uncertain?.main]);


  return (<>

    {showUncertain && (
      <div className="x_edu_content0 x_edu_content0--uncertain _fv" id="uncertain">
        {React.cloneElement(pageComponents.uncertain, {
          ...pageComponents.uncertain.props,
          user,
          avatar,
          publ,
        })}
      </div>
    )}


    {showNarrativePages
      && narrative
      && drawArray.length
      && narrative.pages
      && narrative.pages
        .filter(onePage => onePage && !onePage.beta && onePage.id !== 'uncertain')
        .map((onePage, pageIndex, array) => {
          // const one = narrative[one.id];
          let parameters = {
            // guide: one['guide'],
            // preview: false,
            // handleNew: setShowGuide,
            // scrollToSection: scrollToSection,
            publ: publ,
            nextId: array[pageIndex + 1] ? array[pageIndex + 1].id : null,
            // key: one.id,
            id: onePage.id,
            // design: avatar.design,
            body: onePage.bodygraph,
            // children: <Preview
            //   // {...one['body']}
            //   design={avatar.design ? avatar.design : default_design}
            //   aura={false}
            // />
          };
          // if (penta && narrative[onePage.id].pentaSettings) {
          //   parameters = {
          //     ...parameters,
          //     ...onePage.pentaSettings
          //   }
          // }

          let pageComponent = pageComponents[onePage.id];
          if (showUncertain && pageIndex === 0 && (onePage.id === 'calculate' || onePage.id === 'default')) {
            pageComponent = pageComponents.full;
          }
          let component = pageComponent;

          if (!penta) {
            component = {
              ...component,
              props: {
                user: user,
                avatar: avatar,
                ...component.props,
                ...(showUncertain && pageIndex === 0 ? { noDob: true } : {}),
              }
            }
          } else {
            component = {
              ...component,
              props: {
                ...component.props,
                ...component.props.pentaSettings,
                style: { fontSize: pentaFontSize }

              }
            }
          }

          const avatars = !onePage.utility ? drawArray : [drawArray[0]];


          const handleCloseInfoPop = (e) => {
            if (!e.target.classList.contains('x_click_pop')) {
              document.body.classList.remove('noscroll');
              context.setState.setHighlighted()
              context.setState.setSearch([])

              const removeStudySegments = (pathname) => {
                const segments = pathname.split('/study')
                return segments.length > 1 ? segments[0] : null
              };
              const currentPath = location.pathname;
              const newPath = removeStudySegments(currentPath);
              const queryParams = location.search ? location.search : '';
              if (newPath) navigate(`${newPath}${queryParams}`);
            }
          };


          return (
            <div
              onClick={handleCloseInfoPop}
              key={`page_${onePage.id}`}
              id={onePage['id']}
              ref={pageIndex === 0 ? embedRef : undefined}
              style={{
                // width: (penta && penta.members.length && !one['utility']) ? `${100 / penta.members.length}%` : '100%',
                // width: '100%',
                // width: `${100 / penta.members.length}%`,
                ...component.props.style
              }}
              className={`x_edu_content0 x_edu_content0--${penta ? 'penta' : ''} x_edu_content0--${onePage['id']}  _fv`}
            >




              {Boolean($('page_title', onePage)) && <PageTitle
                onePage={onePage}
                penta={penta}
              />}



              <div className="_fh _fgap4 _fgrow _f100"
              // style={{ width: `${100 / penta.members.length}%` }}
              >


                {
                  avatars
                    .map((oneU, index) => {
                      return (
                        <div
                          key={`page_${oneU.avatar.token}_${onePage.id}`}
                          style={{
                            width: '100%',
                            // width: `${100 / penta.members.length}%`,
                            // overflow: penta ? 'hidden' : 'visible'
                          }}
                        >
                          <Page
                            // key={`page_${oneU.avatar.token}_${onePage.id}`}
                            penta={penta}
                            one={onePage}
                            avatar={oneU.avatar}
                            user={oneU.user}
                            pageIndex={pageIndex}
                            avatarIndex={index}
                            parameters={parameters}
                            component={component}
                          // style={{
                          //   // overflow: 'hidden',
                          //   fntSize: penta ? '0.8em' : '1em'
                          // }}
                          />
                        </div>
                      )
                    }

                    )
                }


              </div>



              {pageIndex === 0 && pageAvatar && pageAvatar.design?.id !== 'dummy' && Boolean(context.me) && <NarrativesList key={`page_narratives`} />}


            </div>
          )
        })}

    <Footer />


  </>

  )
})


export const PageTitle = memo(({
  penta,
  onePage,
  children
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ = context.$;



  return (<>


    <div className="x_edu_content_title">
      <h1 className="x_edu_content_h">{$('page_title', onePage)}</h1>
      {Boolean($('page_description', onePage)) && <div className="x_edu_content_desc">
        <Txt>
          {$('page_description', onePage)}
        </Txt>
      </div>}
    </div>





  </>

  )



})


export const Page = memo(({
  component,
  penta,
  parameters,
  avatarIndex,
  one,
  pageIndex,
  avatar = default_avatar,
  style = {}
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ = context.$;

  parameters = {
    ...parameters,
    design: avatar.design,
    avatar: avatar,
    style: style,
    children: <Preview
      // {...one['body']}
      design={avatar.design ? avatar.design : default_design}
      aura={false}
    />
  }
  // if (!penta) {
  //   parameters = {
  //     ...parameters,
  //     design: avatar.design,
  //     avatar: avatar
  //   }
  // }
  // if (penta) {
  //   parameters = {
  //     ...parameters,
  //     design: avatar.design,
  //     avatar: avatar
  //   }
  // }




  return (<>







    {component &&
      (avatar.design.id !== 'dummy' || !pageIndex) ? <>


      {React.cloneElement(component, {
        ...component.props,
        ...parameters,
        key: `page_${one.id}`
      })}


    </> : <>
      <div
        style={{ ...style }}
        key={`page_${one.id}`} id={one.id}
      // className={`x_edu_content page--${one.id} current--${activeLink}`}
      // className={`x_edu_content`}
      >

        <Soon key={`page_${one.id}`} id={one.id} title={$('page_title', one)} />;
        <div className={`x_edu_page_bg soon`} />
      </div>
    </>}



    <div className='observer inact' />


  </>

  )



})